import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import scrollToElement from 'scroll-to-element';
import theme from '../styles/theme';
import imageLogo from '../assets/images/logo.png';
import imageMenu from '../assets/images/menu.png';
import imageClose from '../assets/images/close.png';
import media from '../styles/media';
import navData from '../data/nav';

export default class Header extends Component {
  state = {
    isMenuOverlayOpen: false,
  };

  handleClick = value => {
    scrollToElement(`#${value}`, {
      offset: -100,
      easing: 'swing',
      duration: 1000,
    });
  };

  handleClickMenu = () => {
    this.setState({ isMenuOverlayOpen: !this.state.isMenuOverlayOpen });
  };

  render() {
    return (
      <Root>
        <HeaderDesktop isMenuOverlayOpen={this.state.isMenuOverlayOpen}>
          <Navigation>
            <LogoImage src={imageLogo} />
            <MenuImage src={imageMenu} onClick={this.handleClickMenu} />
            <NavList>
              {navData &&
                navData.map((value, index) => {
                  return (
                    <li
                      onClick={() => {
                        this.handleClick(value.title);
                      }}
                    >
                      {value.title}
                    </li>
                  );
                })}
            </NavList>
          </Navigation>
        </HeaderDesktop>

        <HeaderMobile isMenuOverlayOpen={this.state.isMenuOverlayOpen}>
          <SubHeaderMobile isMenuOverlayOpen={this.state.isMenuOverlayOpen}>
            <Navigation>
              <LogoImage src={imageLogo} />
              <CloseImage src={imageClose} onClick={this.handleClickMenu} />
            </Navigation>
            <MobileNavList>
              {navData &&
                navData.map((value, index) => {
                  return (
                    <h4
                      onClick={() => {
                        this.handleClick(value.title);
                        this.handleClickMenu();
                      }}
                    >
                      {value.title}
                    </h4>
                  );
                })}
            </MobileNavList>
            <MobileContact>
              <p>info@trellisproperties.ca</p>
              <p>000.000.0000</p>
            </MobileContact>
          </SubHeaderMobile>
        </HeaderMobile>
      </Root>
    );
  }
}

const MobileContact = styled.div`
  position: absolute;
  bottom: 50px;
  transform: translateX(-50%);
  text-align: center;
  left: 50%;
`;

const SubHeaderMobile = styled.header`
  display: ${props => (props.isMenuOverlayOpen ? 'block' : 'none')};
  background-color: ${theme.blackPrimary};
  height: 75px;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 20px;
  padding-bottom: 20px;
  h1 {
    font-family: 'korolev';
    font-style: normal;
    font-weight: 300;
  }
  @media (min-width: ${media.md}) {
    padding-left: 70px;
    padding-right: 70px;
  }
`;

const MobileNavList = styled.ul`
  cursor: pointer;
  position: absolute;
  top: 35%;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
  h4 {
    font-family: 'korolev';
    font-style: normal;
    font-weight: 500;
    color: white;
    font-size: 24px;
    margin-bottom: 30px;
  }
`;

const Root = styled.div`
  /* position: fixed; */
  top: 0;
  width: 100%;
  z-index: 999;
`;

const HeaderMobile = styled.div`
  z-index: 999;
  visibility: ${props => (props.isMenuOverlayOpen ? 'visible' : 'hidden')};
  height: 100vh;
  width: 100%;
  background-color: #f87642;
  position: fixed;
  top: 0%;
  transition: all 0.4s ease-out;
  opacity: ${props => (props.isMenuOverlayOpen ? '1' : '0')};
`;

const NavList = styled.ul`
  display: none;
  @media (min-width: ${media.md}) {
    cursor: pointer;
    display: flex;
    width: 314px;
    justify-content: space-between;
    list-style: none;
    text-transform: uppercase;
    li {
      font-family: 'korolev';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      position: relative;
    }
    li:after {
      content: '';
      display: block;
      margin: auto;
      height: 2px;
      width: 0px;
      background: transparent;
      transition: width 0.5s ease, background-color 0.5s ease;
    }
    li:hover:after {
      width: 100%;
      background: #f57f29;
    }
  }
`;

const HeaderDesktop = styled.header`
  background-color: ${theme.blackPrimary};
  height: 75px;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 20px;
  padding-bottom: 20px;
  h1 {
    font-family: 'korolev';
    font-style: normal;
    font-weight: 300;
  }
  @media (min-width: ${media.md}) {
    padding-left: 70px;
    padding-right: 70px;
  }
`;

const CloseImage = styled.img`
  width: 16px;
  height: 16px;
  @media (min-width: ${media.md}) {
    display: none;
  }
`;

const MenuImage = styled.img`
  width: 26px;
  height: 16px;
  @media (min-width: ${media.md}) {
    display: none;
  }
`;

const LogoImage = styled.img`
  width: 125px;
  height: 35px;
`;

const Navigation = styled.nav`
  display: flex;
  color: white;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./src/components/Header.js